import { Compositor } from './compositor';
export class UserCompositor extends Compositor {
    constructor(config) {
        super({
            videoStarter: config.videoStarter,
            stats: config.stats,
        });
    }
    postProcessingHook() { }
}
//# sourceMappingURL=user_compositor.js.map